



































import { Component, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import OwnerFormComponent from '@/components/public/owner-form.component.vue';
import AuthenticationModule from '@/store/modules/authentication.module';
import store from '@/store';
import { getModule } from 'vuex-module-decorators';
import { REGISTERED_TAG_MODULE_NAME } from '@/store/modules/registered-tag.module';
import { mapState } from 'vuex';
import { RegisteredTag } from '@/models/DTO/registered-tag/registered-tag.model';
import PublicCancelMixin from '@/mixins/public-cancel.mixin';

const authModule: AuthenticationModule = getModule(AuthenticationModule, store);

@Component({
  components: {
    OwnerFormComponent
  },
  computed: {
    ...mapState(REGISTERED_TAG_MODULE_NAME, ['currentRegisteredTag'])
  }
})
export default class OwnerComponent extends mixins(PublicCancelMixin) {
  @Prop({
    default: ''
  })
  public title: string;

  public currentRegisteredTag: RegisteredTag | null;

  public get tagCode(): string {
    // only sent when registering a new tag
    return this.$route.params.tagCode;
  }

  public async onCancelClick() {
    await authModule.tagResetMatchAction();

    this.onCancel();
  }
}
